// Mapping of AWS Polly Standard voices by language.
// Documentation reference: https://docs.aws.amazon.com/polly/latest/dg/standard-voices.html#standard-voicelist

export const POLLY_STANDARD_VOICE_MAP = {
  'ar-SA': {
    languageName: 'Arabic (Saudi Arabia)',
    voiceId: 'Zeina'
  },
  'da-DK': {
    languageName: 'Danish (Denmark)',
    voiceId: 'Naja'
  },
  'de-DE': {
    languageName: 'German (Germany)',
    voiceId: 'Marlene'
  },
  'en-AU': {
    languageName: 'English (Australia)',
    voiceId: 'Nicole'
  },
  'en-GB': {
    languageName: 'English (United Kingdom)',
    voiceId: 'Amy'
  },
  'en-IN': {
    languageName: 'English (India)',
    voiceId: 'Raveena'
  },
  'en-US': {
    languageName: 'English (United States)',
    voiceId: 'Joanna'
  },
  'es-ES': {
    languageName: 'Spanish (Spain)',
    voiceId: 'Conchita'
  },
  'es-MX': {
    languageName: 'Spanish (Mexico)',
    voiceId: 'Mia'
  },
  'fr-CA': {
    languageName: 'French (Canada)',
    voiceId: 'Chantal'
  },
  'fr-FR': {
    languageName: 'French (France)',
    voiceId: 'Celine'
  },
  'hi-IN': {
    languageName: 'Hindi (India)',
    voiceId: 'Aditi'
  },
  'it-IT': {
    languageName: 'Italian (Italy)',
    voiceId: 'Carla'
  },
  'ja-JP': {
    languageName: 'Japanese (Japan)',
    voiceId: 'Mizuki'
  },
  'ko-KR': {
    languageName: 'Korean (South Korea)',
    voiceId: 'Seoyeon'
  },
  'nb-NO': {
    languageName: 'Norwegian (Bokmål)',
    voiceId: 'Liv'
  },
  'nl-NL': {
    languageName: 'Dutch (Netherlands)',
    voiceId: 'Lotte'
  },
  'pl-PL': {
    languageName: 'Polish (Poland)',
    voiceId: 'Ewa'
  },
  'pt-BR': {
    languageName: 'Portuguese (Brazil)',
    voiceId: 'Vitoria'
  },
  'pt-PT': {
    languageName: 'Portuguese (Portugal)',
    voiceId: 'Ines'
  },
  'ro-RO': {
    languageName: 'Romanian (Romania)',
    voiceId: 'Carmen'
  },
  'ru-RU': {
    languageName: 'Russian (Russia)',
    voiceId: 'Tatyana'
  },
  'sv-SE': {
    languageName: 'Swedish (Sweden)',
    voiceId: 'Astrid'
  },
  'tr-TR': {
    languageName: 'Turkish (Turkey)',
    voiceId: 'Filiz'
  },
  'zh-CN': {
    languageName: 'Chinese (Mandarin)',
    voiceId: 'Zhiyu'
  }
};

// English variants hidden from the translation-language pickers (owner decision, 2026-08-18):
// with all-English news sources an English "translation" target is degenerate, but en-GB/en-US
// are retained for future non-English sources. The voice MAP above keeps every entry — it still
// serves voiceId lookup and display names for anything already saved with these codes.
const HIDDEN_TRANSLATION_TARGETS = ['en-AU', 'en-IN'];

export const POLLY_STANDARD_LANGUAGE_OPTIONS = Object.entries(POLLY_STANDARD_VOICE_MAP)
  .filter(([languageCode]) => !HIDDEN_TRANSLATION_TARGETS.includes(languageCode))
  .map(
    ([languageCode, { languageName, voiceId }]) => ({
      languageCode,
      languageName,
      voiceId
    })
  );

export function getDefaultPollyVoiceForLanguage(languageCode) {
  if (!languageCode) {
    return null;
  }
  const mapping = POLLY_STANDARD_VOICE_MAP[languageCode];
  return mapping ? mapping.voiceId : null;
}

export function getPollyLanguageName(languageCode) {
  const mapping = POLLY_STANDARD_VOICE_MAP[languageCode];
  return mapping ? mapping.languageName : languageCode;
}
